// src/references/referencing-styles.ts
function isReferencingStyle(style) {
  return [
    "APA",
    "MLA",
    "MHRA",
    "Vancouver",
    "OSCOLA",
    "Oxford",
    "ChicagoA",
    "ChicagoB",
    "Harvard",
    "AGLC",
    "IEEE",
    "NZ Law",
    "Animal Behaviour",
    "RSNZ",
    "AMA",
    "ACS"
  ].includes(style);
}
function validateReferencingStyle(style) {
  if (style && isReferencingStyle(style)) {
    return style;
  }
  return null;
}
function formatReferencingStyle(style) {
  if (style === "ChicagoA") {
    return "Chicago - Notes & Bibliography";
  }
  if (style === "ChicagoB") {
    return "Chicago - Author-Date";
  }
  return style;
}
function isHangingIndent(referencingStyle) {
  if (referencingStyle === null) {
    return false;
  }
  const valid = ["APA", "MLA", "ChicagoB"];
  return valid.includes(referencingStyle);
}
function isFootnotingEnabled(referencingStyle) {
  if (referencingStyle === null) {
    return false;
  }
  const valid = [
    "OSCOLA",
    "Oxford",
    "ChicagoA",
    "AGLC",
    "MHRA",
    "NZ Law"
  ];
  return valid.includes(referencingStyle);
}
function referencesTitle(referencingStyle) {
  if (isFootnotingEnabled(referencingStyle)) {
    return "Bibliography";
  } else {
    return "References";
  }
}
var BASE_STYLES = {
  cadmus: [
    "APA",
    "MLA",
    "Harvard",
    "Vancouver",
    "IEEE",
    "ChicagoB",
    "Animal Behaviour"
  ],
  uwa: ["APA", "MLA", "Vancouver"],
  swinburne: ["APA", "Harvard"],
  uoa: ["APA", "MLA", "Harvard", "Vancouver"],
  acu: ["APA", "MLA", "Harvard", "Vancouver", "IEEE", "ChicagoB"],
  wsu: ["APA", "MLA", "Harvard", "Vancouver"],
  manchester: ["APA", "MLA", "Harvard", "Vancouver"],
  maynooth: ["APA", "MLA", "Harvard", "Vancouver"],
  qmul: ["APA", "MLA", "Harvard", "Vancouver"],
  uob: ["APA", "MLA", "Harvard", "Vancouver"],
  greenwich: ["APA", "MLA", "Harvard", "Vancouver"],
  zayed: ["APA", "MLA", "Harvard", "Vancouver", "IEEE"],
  jamessprunt: ["APA", "MLA", "Harvard", "Vancouver"],
  waikato: [
    "ACS",
    "AMA",
    "Animal Behaviour",
    "APA",
    "ChicagoB",
    "IEEE",
    "RSNZ"
  ],
  und: ["APA", "AMA"],
  default: ["APA", "Harvard", "Vancouver"]
};
var FOOTNOTE_STYLES = {
  cadmus: ["ChicagoA", "MHRA", "OSCOLA", "Oxford", "AGLC"],
  massey: ["ChicagoA"],
  usq: ["AGLC", "Oxford"],
  unisc: ["AGLC"],
  federation: ["ChicagoA"],
  bcu: ["OSCOLA", "MHRA", "ChicagoA"],
  ucl: ["OSCOLA", "MHRA", "ChicagoA"],
  ljmu: ["OSCOLA", "MHRA", "ChicagoA"],
  uob: ["OSCOLA", "MHRA", "ChicagoA"],
  gla: ["OSCOLA", "MHRA", "ChicagoA"],
  qmul: ["OSCOLA", "MHRA", "ChicagoA"],
  exeter: ["OSCOLA", "MHRA", "ChicagoA"],
  st_andrews: ["OSCOLA", "MHRA", "ChicagoA"],
  manchester: ["OSCOLA", "MHRA", "ChicagoA"],
  maynooth: ["OSCOLA", "MHRA", "ChicagoA"],
  greenwich: ["OSCOLA", "MHRA", "ChicagoA"],
  londonmet: ["OSCOLA", "MHRA", "ChicagoA"],
  liverpool: ["OSCOLA", "MHRA", "ChicagoA"],
  lse: ["OSCOLA", "MHRA", "ChicagoA"],
  kcl: ["OSCOLA", "MHRA", "ChicagoA"],
  waikato: ["NZ Law", "MHRA"],
  und: ["ChicagoA", "AGLC"],
  default: ["ChicagoA", "AGLC"]
};
function getTenantStyles(tenant, footnoteReferencingEnabled = false) {
  const base = lookupTenant(BASE_STYLES, tenant);
  if (footnoteReferencingEnabled) {
    const extra = lookupTenant(FOOTNOTE_STYLES, tenant);
    return base.concat(extra);
  }
  return base;
}
function lookupTenant(styles, tenant) {
  for (const [prefix, list] of Object.entries(styles)) {
    if (tenant.startsWith(prefix)) {
      return list;
    }
  }
  return styles.default;
}

export {
  isReferencingStyle,
  validateReferencingStyle,
  formatReferencingStyle,
  isHangingIndent,
  isFootnotingEnabled,
  referencesTitle,
  getTenantStyles
};
//# sourceMappingURL=chunk-4L67CLDF.mjs.map